"use strict";

var _regeneratorRuntime = require("/workspace/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/workspace/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/workspace/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/workspace/node_modules/@babel/runtime/helpers/createClass");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _types = _interopRequireDefault(require("../types"));

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.scan = scan, exports.Scanner = void 0;
/**
* @module radspec/scanner
*/

/**
* Enum for scanner state.
*
* @readonly
* @enum {string}
*/

var SCANNER_STATE = {
  OK: "OK",
  ERROR: "ERROR"
};
/**
* A scanner that identifies tokens in a source string.
*
* @class Scanner
* @param {string} source The source code
* @property {string} state The state of the parser (`OK` or `ERROR`)
* @property {string} source The source code
* @property {number} cursor
* @property {Array<Token>} tokens The currently identified tokens
*/

var Scanner =
/*#__PURE__*/
function () {
  function Scanner(source) {
    _classCallCheck(this, Scanner);

    this.state = SCANNER_STATE.OK, this.isInExpression = !1, this.source = source, this.cursor = 0, this.tokens = [];
  }
  /**
  * Scans a single token from source and pushes it to `Scanner.tokens`.
  *
  * @return {void}
  */


  _createClass(Scanner, [{
    key: "scanToken",
    value: function scanToken() {
      var current = this.consume();
      if ("`" === current) return this.isInExpression = !this.isInExpression, void this.emitToken("TICK"); // We haven't hit a tick yet, so we're not in an expression

      if (!this.isInExpression) {
        // Scan until tick
        var monologue = current;

        for (; "`" !== this.peek() && !this.eof();) {
          monologue += this.consume();
        }

        return void this.emitToken("MONOLOGUE", monologue);
      }

      switch (current) {
        // Single character tokens
        case "(":
          this.emitToken("LEFT_PAREN");
          break;

        case ")":
          this.emitToken("RIGHT_PAREN");
          break;

        case ",":
          this.emitToken("COMMA");
          break;

        case ".":
          this.emitToken("DOT");
          break;

        case ":":
          this.emitToken("COLON");
          break;

        case "-":
          this.emitToken("MINUS");
          break;

        case "+":
          this.emitToken("PLUS");
          break;

        case "^":
          this.emitToken("POWER");
          break;

        case "*":
          this.emitToken("STAR");
          break;

        case "/":
          this.emitToken("SLASH");
          break;

        case "%":
          this.emitToken("MODULO");
          break;

        case "?":
          this.emitToken("QUESTION_MARK");
          break;

        case "@":
          this.emitToken("AT");
          break;
        // One or two character tokens

        case "!":
          this.emitToken(this.matches("=") ? "BANG_EQUAL" : "BANG");
          break;

        case "=":
          this.emitToken(this.matches("=") ? "EQUAL_EQUAL" : "EQUAL");
          break;

        case "<":
          this.emitToken(this.matches("=") ? "LESS_EQUAL" : "LESS");
          break;

        case ">":
          this.emitToken(this.matches("=") ? "GREATER_EQUAL" : "GREATER");
          break;
        // Two character tokens

        case "|":
          this.matches("|") ? this.emitToken("DOUBLE_VERTICAL_BAR") : this.report("Unexpected single \"|\" (expecting two)");
          break;
        // Whitespace

        case " ":
        case "\r":
        case "\n":
        case "\t":
          break;
        // Multi-character tokens

        default:
          var NUMBERS = /[0-9]/;

          if (NUMBERS.test(current)) {
            var number = current,
                type = "NUMBER"; // Detect hexadecimals

            if ("0" === current && "x" === this.peek()) for (type = "HEXADECIMAL", number += this.consume(); /[0-9a-f]/i.test(this.peek());) {
              number += this.consume();
            } else for (; NUMBERS.test(this.peek());) {
              number += this.consume();
            }
            this.emitToken(type, number);
            break;
          }

          var IDENTIFIERS = /[_$a-z0-9]/i;

          if (IDENTIFIERS.test(current)) {
            var identifier = current;

            for (; IDENTIFIERS.test(this.peek());) {
              identifier += this.consume();
            }

            if ("true" === identifier || "false" === identifier) {
              this.emitToken("BOOLEAN", identifier);
              break;
            }

            _types.default.isType(identifier) ? this.emitToken("TYPE", identifier) : this.emitToken("IDENTIFIER", identifier);
            break;
          }

          if ("'" === current || "\"" === current) {
            var string = "";

            for (; !this.matches("'") && !this.matches("\"");) {
              string += this.consume();
            }

            this.emitToken("STRING", string);
            break;
          }

          this.report("Unexpected character \"".concat(current, "\""));
      }
    }
    /**
    * Push a token to `Scanner.tokens`
    *
    * @param {string} type The token type
    * @param {string?} value The token value
    * @return {void}
    */

  }, {
    key: "emitToken",
    value: function emitToken(type, value) {
      var token = {
        type: type
      };
      value && (token.value = value), this.tokens.push(token);
    }
    /**
    * Get the current character and increase the cursor by 1
    *
    * @return {string}
    */

  }, {
    key: "consume",
    value: function consume() {
      return this.cursor++, this.source[this.cursor - 1];
    }
    /**
    * Get the character under the cursor without consuming it.
    *
    * @return {string}
    */

  }, {
    key: "peek",
    value: function peek() {
      return this.source[this.cursor];
    }
    /**
    * Checks if the next character matches an expected one.
    *
    * Increases the cursor by 1 if the character matches.
    *
    * @param {string} expected The character to expect
    * @return {boolean} True if the next character matches, otherise false
    */

  }, {
    key: "matches",
    value: function matches(expected) {
      return !this.eof() && !(this.peek() !== expected) && (this.cursor++, !0);
    }
    /**
    * Scans source and returns a list of tokens.
    *
    * @return {Array<Token>}
    */

  }, {
    key: "scan",
    value: function () {
      var _scan = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                for (; !this.eof();) {
                  this.scanToken();
                }

                return _context.abrupt("return", this.state === SCANNER_STATE.ERROR ? void console.error("Errors encountered while scanning source") : this.tokens);

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function scan() {
        return _scan.apply(this, arguments);
      }

      return scan;
    }()
    /**
    * Returns true if we've reached the end of source, otherwise false.
    *
    * @return {boolean}
    */

  }, {
    key: "eof",
    value: function eof() {
      return this.cursor >= this.source.length;
    }
    /**
    * Prints an error with location information to `stderr`
    * and sets the scanner state to `SCANNER_STATE.ERROR`
    *
    * @param {string} error
    * @return {void}
    */

  }, {
    key: "report",
    value: function report(error) {
      this.state = SCANNER_STATE.ERROR, console.error("Error (".concat(this.cursor, "): ").concat(error));
    }
  }]);

  return Scanner;
}();
/**
* Scans source and returns a list of tokens.
*
* @memberof radspec/scanner
* @param  {string} source
* @return {Array<Token>}
*/


exports.Scanner = Scanner;

function scan(source) {
  return new Scanner(source).scan();
}